/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

/**
 * Model for Resume Sub-Section data.
 */
export class ResumeSubSection {
  /**
   * Array of content attached to the sub-section.
   */
  portfolioContent : Array<any> = new Array<any>();

  /**
   * Default constructor.
   *
   * @param init Optional partial object definition.
   */
  constructor(init?: Partial<ResumeSubSection>) {
    Object.assign(this, init);
  }
}
